import { render, staticRenderFns } from "./Admin_Dashboard.vue?vue&type=template&id=602197a9&scoped=true&"
import script from "./Admin_Dashboard.vue?vue&type=script&lang=js&"
export * from "./Admin_Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Admin_Dashboard.vue?vue&type=style&index=0&id=602197a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602197a9",
  null
  
)

export default component.exports